'use client';
import { useWindowDimensions } from '@/hook';
import styles from './styles.module.scss';

const DesktopWrapper = ({
  children,
  style,
}: {
  children: JSX.Element | JSX.Element[];
  style?: any;
}) => {
  const { width } = useWindowDimensions();
  const IS_DESKTOP = width >= 850;
  return (
    <>
      {IS_DESKTOP && (
        <span style={style} className={styles.desktop_container}>
          {children}
        </span>
      )}
    </>
  );
};
export default DesktopWrapper;
